/** Same copy as the basketmouth.money IIS shell and Affiliate.SiteSeoFooter. */
const BASKETMOUTH_BRAND_SEARCH_LINE =
  "BasketMouth Money — send money worldwide with Basketmouth (Bright Okpocha) at basketmouth.money, with Mito Money.";

/** Retail widget copy must never surface Rhemito / FURP as the public brand. */
export function rewriteRetailBrandCopy(text: string): string {
  if (!text) return text;
  return text
    .replace(/powered by Rhemito/gi, "powered by mito.money")
    .replace(/powered by FURP/gi, "powered by mito.money")
    .replace(/powered by MITO\b/gi, "powered by mito.money")
    .replace(/\bRhemito\b/g, "mito.money")
    .replace(/\bFURP\b/g, "mito.money");
}

function pickRaw(obj: any, ...names: string[]): string {
  if (!obj || typeof obj !== "object") return "";
  for (const name of names) {
    const value = obj[name];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  const lower: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    lower[key.toLowerCase()] = value;
  }
  for (const name of names) {
    const value = lower[name.toLowerCase()];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

/**
 * GetAffiliateConfiguration is sometimes the DTO at the root and sometimes
 * { responseType, data: dto }. HomeFooter must read the DTO either way.
 */
export function unwrapAffiliateConfig(body: any): any {
  if (!body || typeof body !== "object") return body;
  const inner = body.data;
  const innerName = pickRaw(
    inner,
    "affiliateName",
    "AffiliateName",
    "affiliatename",
  );
  const outerName = pickRaw(
    body,
    "affiliateName",
    "AffiliateName",
    "affiliatename",
  );
  if (
    inner &&
    typeof inner === "object" &&
    !Array.isArray(inner) &&
    innerName &&
    !outerName
  ) {
    return inner;
  }
  return body;
}

export function pickConfigString(obj: any, ...names: string[]): string {
  return pickRaw(obj, ...names);
}

export function resolveSiteSeoFooter(config: any, hostname?: string): string {
  const fromConfig = pickRaw(
    config,
    "siteSeoFooter",
    "SiteSeoFooter",
    "siteseofooter",
  );
  if (fromConfig) return rewriteRetailBrandCopy(fromConfig);

  const host = (
    hostname ||
    (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  if (
    host === "basketmouth.mito.money" ||
    host === "basketmouth.money" ||
    host === "www.basketmouth.money"
  ) {
    return BASKETMOUTH_BRAND_SEARCH_LINE;
  }
  return "";
}
